import { Box, Typography } from '@mui/material';

const columns = (plotFor, units, renderRunCell, renderRunHideCell, customColumn) => [
  {
    field: 'hide',
    headerName: 'Show',
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        Show
      </Typography>
      </Box>
    ),
    width: 50,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderRunHideCell
  },
  {
    field: 'runNumber',
    headerName: 'Run #',
    cellClassName: 'cellLink',
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        Run #
      </Typography>
      </Box>
    ),
    width: 60,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderRunCell
  },
  {
    field: 'hole_depth',
    headerName: `Hole Depth (${units?.inputs?.hole_depth?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
       Hole
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
      Depth ({units?.inputs?.hole_depth?.label})
      </Typography>
      </Box>
    ),
    width: 85,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.inputs?.hole_depth?.decimals);
    },
  },
  {
    field: 'rop',
    headerName: `ROP (${units?.inputs?.rop?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
       ROP
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
      ({units?.inputs?.rop?.label})
      </Typography>
      </Box>
    ),
    width: 85,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.inputs?.rop?.decimals);
    },
  },
  {
    field: 'rpm',
    headerName: `RPM (${units?.inputs?.rpm?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
       RPM
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
      ({units?.inputs?.rpm?.label})
      </Typography>
      </Box>
    ),
    width: 85,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.inputs?.rpm?.decimals);
    },
  },
  {
    field: 'flow_in',
    headerName: `Flow Rate (${units?.inputs?.flow_in?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
       Flow Rate
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
      ({units?.inputs?.flow_in?.label})
      </Typography>
      </Box>
    ),
    width: 85,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.inputs?.flow_in?.decimals);
    },
  },
  {
    field: 'mw',
    headerName: `MW (${units?.inputs?.mw?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
       MW
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
      ({units?.inputs?.mw?.label})
      </Typography>
      </Box>
    ),
    width: 55,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.inputs?.mw?.decimals);
    },
  },
  {
    field: 'casing_shoe',
    headerName: `Casing Shoe ${plotFor} (${units?.results?.depth_points?.ecd?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        Casing Shoe
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        {plotFor} ({units?.results?.depth_points?.ecd?.label})
      </Typography>
      </Box>
    ),
    width: 100,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.results?.depth_points?.esd?.decimals);
    },
  },
  {
    field: 'landing_point',
    headerName: `Landing Point ${plotFor} (${units?.results?.depth_points?.ecd?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        Landing Point
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
       {plotFor} ({units?.results?.depth_points?.ecd?.label})
      </Typography>
      </Box>
    ),
    width: 100,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.results?.depth_points?.esd?.decimals);
    },
  },
  {
    field: 'bottom_hole',
    headerName: `Bottom Hole ${plotFor} (${units?.results?.depth_points?.ecd?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        Bottom Hole
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
      {plotFor} ({units?.results?.depth_points?.ecd?.label})
      </Typography>
      </Box>
    ),
    width: 100,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.results?.depth_points?.esd?.decimals);
    },
  },
  {
    field: customColumn.field,
    headerName: `${customColumn.header} ${plotFor} (${units?.results?.depth_points?.ecd?.label})`,
    hide: customColumn.show,
    renderHeader: () => (
        <Box>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        {customColumn.header}
        </Typography>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        {plotFor} ({units?.results?.depth_points?.ecd?.label})
        </Typography>
        </Box>
    ),
    width: 140,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'dynamic_sbp',
    headerName: `Dynamic SBP (${units?.results?.summary?.target_sbp?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
       Dynamic
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
      SBP ({units?.results?.summary?.target_sbp?.label})
      </Typography>
      </Box>
    ),
    width: 85,
    headerAlign: 'center',
    align: 'center',
    hide: plotFor === 'ESD',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.results?.summary?.target_sbp?.decimals);
    },
  },
  {
    field: 'connection_sbp',
    headerName: `Connection SBP (${units?.results?.depth_points?.connection_sbp?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        Connection
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
       SBP ({units?.results?.depth_points?.connection_sbp?.label})
      </Typography>
      </Box>
    ),
    width: 100,
    headerAlign: 'center',
    align: 'center',
    hide: plotFor === 'ECD',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      return isNaN(value) ? params.value : value.toFixed(units?.results?.depth_points?.connection_sbp?.decimals);
    },
  },
];
export default columns;
